import defaults from './numberoptions'

function format (input, opt = defaults) {
  if (typeof input === 'number') {
    input = input.toFixed(fixed(opt.precision))
  }
  var negative = input.indexOf('-') >= 0 ? '-' : ''  
  var numbers = opt.allowDecimal ? onlyFloat(input) : onlyNumbers(input)  
  var currency = numbers.indexOf('.') > -1 && opt.allowDecimal ? 
  parseFloat(numbers) :
  numbersToCurrency(numbers, opt.precision);
  var letIndex = numbers.indexOf('.')
  if (opt.allowDecimal && letIndex > -1) {
    if (letIndex === numbers.length - 1) {
      return input;
    } else {      
      /**
       * [ERP-304] 소수점 값에 '0'이 입력 안된는 오류
       * 소수점 마지막 값이 '0'일 경우, parseFloat() 메소드 적용하지 않고 반환
       * parseFloat() 메소드를 적용하면, 입력한 값의 마지막 값인 '0'은 삭제됨
       * ex) Case 1. "1.0"을 입력하면, "1"로 반환
       * Case 2. "1.10"을 입력하면, "1.1"로 반환
       */
      if( numbers.slice(-1) == "0" ) {
        return numbers;
      }
      currency = parseFloat(numbers);
    }
  } else {
    currency = numbersToCurrency(numbers, opt.precision);
  }
  var parts = toStr(currency).split('.')
  var integer = parts[0]
  var decimal = parts[1]
  integer = addThousandSeparator(integer, opt.thousands)
  return opt.prefix + negative + joinIntegerAndDecimal(integer, decimal, opt.decimal) + opt.suffix
  
}

function unformat (input, precision, allowDecimal) {
  var negative = input.indexOf('-') >= 0 ? -1 : 1
  var numbers = allowDecimal ? onlyFloat(input) : onlyNumbers(input);
  if (allowDecimal) { 
    /**
       * [ERP-304] 소수점 값에 '0'이 입력 안된는 오류
       * 소수점 마지막 값이 '0'일 경우, numbers * negative 연산하지 않고 반환
       * numbers * negative 연산을 적용하면, 입력한 값의 마지막 값인 '0'은 삭제됨
       * ex) Case 1. "1.0"을 입력하면, 1.0 * 1 = 1 로 반환
       * Case 2. "1.10"을 입력하면, 1.10 * 1 = 1.1 로 반환
       */
    var letIndex = numbers.indexOf('.');
    if (letIndex > -1 && numbers.slice(-1) == "0") {
      if( negative ) return numbers;
      else return numbers * negative;
    } else {      
      return numbers * negative;
    }
  }
  
  var currency = numbersToCurrency(numbers, precision)
  return parseFloat(currency) * negative
}

function onlyNumbers (input) {
  return toStr(input).replace(/\D+/g, '') || '0'
}

function onlyFloat (input) {
  return toStr(input).replace(/[^0-9.]/g, '') || '0'
}

// Uncaught RangeError: toFixed() digits argument must be between 0 and 20 at Number.toFixed
function fixed (precision) {
  return between(0, precision, 20)
}

function between (min, n, max) {
  return Math.max(min, Math.min(n, max))
}

function numbersToCurrency (numbers, precision) {
  var exp = Math.pow(10, precision)
  var float = parseFloat(numbers) / exp
  return float.toFixed(fixed(precision))
}

function addThousandSeparator (integer, separator) {
  return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`)
}

// function currencyToIntegerAndDecimal (float) {
//   return toStr(float).split('.')
// }

function joinIntegerAndDecimal (integer, decimal, separator) {
  return decimal ? integer + separator + decimal : integer
}

function toStr (value) {
  return value ? value.toString() : ''
}

function setCursor (el, position) {
  var setSelectionRange = function () { el.setSelectionRange(position, position) }
  if (el === document.activeElement) {
    setSelectionRange()
    setTimeout(setSelectionRange, 1) // Android Fix
  }
}

// https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events#The_old-fashioned_way
function event (name) {
  var evt = document.createEvent('Event')
  evt.initEvent(name, true, true)
  return evt
}

export {
  format,
  unformat,
  setCursor,
  event
}